import { User } from '@typing/global';

export const TableHeadCells = [
  {
    id: 'firstname',
    label: 'Name',
    sort: true,
    nested: 'firstname',
    style: { textWrap: 'nowrap', textTransform: 'capitalize' },
    render: (row: User) => {
      return `${row.firstname} ${row.lastname}`;
    },
  },
  {
    id: 'email',
    label: 'Email',
    sort: true,
    nested: 'email',
    style: { textWrap: 'nowrap' },
  },
  {
    id: 'companyName',
    label: 'Company Name',
    sort: true,
    nested: 'companyName',
    style: { textWrap: 'nowrap' },
  },
  {
    id: 'actions',
    label: 'Actions',
  },
];
export const TableDataFields = ['firstname', 'email', 'companyName', 'actions'];
